import React, { forwardRef } from "react";
import StickerLabel from "./StickerLabel";

// Off-screen area that the sticker printer captures.
// Kept in the DOM (not display:none) so QR SVGs render/measure correctly; we
// hide it from the user with absolute positioning + off-screen offset. During
// printing, STICKER_PRINT_CSS repositions it on-page and hides everything else.
const StickerPrintArea = forwardRef(function StickerPrintArea({ boxes }, ref) {
  return (
    <div
      id="sticker-print-root"
      style={{
        position: "absolute",
        left: "-10000px",
        top: 0,
        width: "4in",
        // height grows with content
      }}
      aria-hidden="true"
    >
      <div ref={ref}>
        {(boxes || []).map((b) => (
          <StickerLabel key={b.Box_ID || b.StickerCode} box={b} />
        ))}
      </div>
    </div>
  );
});

export default StickerPrintArea;

// Full print stylesheet for Rollo 4x6 thermal labels. This is injected into
// <head> only while a sticker is printing and removed right after, so its 4x6
// @page rule and "hide everything else" rules never leak into the app's other
// browser prints (packing list / daily cash use Letter; customer statement uses
// a plain window.print()). We drive printing with window.print() + this scoped
// sheet instead of react-to-print, because react-to-print prints via a hidden
// iframe that mobile browsers (iOS Safari / Android Chrome) ignore — they print
// the whole screen instead of just the label.
export const STICKER_PRINT_CSS = `
  @page { size: 4in 6in; margin: 0; }
  @media print {
    /* Hide the whole app, then reveal only the sticker area. visibility (not
       display:none) keeps the QR SVG rendered. */
    body.printing-sticker * { visibility: hidden !important; }
    body.printing-sticker #sticker-print-root,
    body.printing-sticker #sticker-print-root * { visibility: visible !important; }
    body.printing-sticker #sticker-print-root {
      position: absolute !important;
      left: 0 !important;
      top: 0 !important;
      width: 4in !important;
    }
    body.printing-sticker .sticker-label { width: 4in; height: 6in; }
  }
`;

// Back-compat: some callers may still import the old @page-only constant.
export const STICKER_PAGE_STYLE = STICKER_PRINT_CSS;
